import React, { useMemo, useContext } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { OpenInNew } from '@mui/icons-material';

// Types
import { TCustomGFIDKPProps } from '@/@types/views/map';

// Custom
import MapCardActionButton from '@/ui/MapCard/MapCardActionButton';
import DataController from '@/lib/DataController';
import modelUkopani from '@/models/groblja/grobno_mjesto_ukopani';
import UserContext from '@/context/UserContext/UserContext';
import Permissions from '@/lib/permissions';
import DCTable from '@/ui/Table/DCTable';
import AdvancedGrobljaDialog from '@/views/Groblja/RegistarKorisnika/AdvancedGrobljaDialog';

const GMUkopaniButton = (props: TCustomGFIDKPProps) => {
  const identifier = 'ukopani';

  const userContext = useContext(UserContext);

  const canEdit = userContext?.hasAnyPermission([Permissions.GrobljaManageOsnovniRegistri]);

  const { t } = useTranslation();

  const { record, onToggle } = props;

  const recordId = useMemo(
    () =>
      record ? (record.id ? record.id : record.fid ? record.fid : null) : null,
    [record]
  );

  const grobljeId = useMemo(
      () => record?.groblje_id ?? null,
      [record]
  );

  const registarUmrlihId = useMemo(
      () => record?.registar_umrlih_id ?? null,
      [record]
  );

  const dcUkopani = useMemo(
    () =>
      new DataController(
        modelUkopani,
        `groblja/grobna-mjesta/${recordId}/ukopani`
      ),
    [recordId]
  );

  const ukopaniTable = (
    <DCTable
      allowExport
      title="groblja:titles.gm_ukopani"
      size="small"
      tableName="ukopani"
      identifier='ukopani-gs'
      viewName="secondary"
      dc={dcUkopani}
      allowSelection="one"
      allowAdd={canEdit}
      allowEdit={canEdit}
      allowDelete={canEdit}
      allowRowAction={() => false}
      onRowAction={() => {}}
      disableControls={false}
      allowColumnPicker={true}
      dialogComponent={AdvancedGrobljaDialog}
      foreignKeyValue={{ grobno_mjesto_id: recordId, groblje_id: grobljeId, registar_umrlih_id: registarUmrlihId }}
      // TODO add history
    />
  );

  const handleToggleUkopani = () => {
    onToggle(ukopaniTable, identifier);
  };

  return (
    <MapCardActionButton
      startIcon={<AssignmentIndIcon />}
      onClick={handleToggleUkopani}
      endIcon={<OpenInNew />}
    >
      {t('titles.ukopani')}
    </MapCardActionButton>
  );
};

export default GMUkopaniButton;
